// ./apollo-client.js

import { ApolloClient, createHttpLink, InMemoryCache } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { supabase } from './supabase-client';

const httpLink = createHttpLink({
  // this is our Deno instance running in Docker on DigitalOcean
  uri: process.env.NEXT_PUBLIC_THAQALAYN_DEV_SERVER_URL || 'https://api.thaqalayn.net:8000/graphql',
  // uri: 'http://127.0.0.1:8080/graphql',
});

const authLink = setContext(async (_, { headers }) => {
  const token = (await supabase.auth.getSession()).data.session?.access_token;

  return {
    headers: {
      ...headers,
      apiKey: 'frontend-key',
      authorization: token ? `Bearer ${token}` : '',
    },
  };
});

const client = new ApolloClient({
  // uri: 'http://127.0.0.1:8080/graphql',
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
});

export default client;
